import React from "react";
import MobileImage from "./Mobile-icon.svg";
import WebImage from "./web.svg";
import DevOpsImage from "./Devops.svg";
import ArtImage from "./Art.svg";
import GameImage from "./Game.svg";
import { useHistory } from "react-router";


export const Card = (props) => {
  // function Card(title,imageUrl,body){
  return (
    <div className="Card-Container" onClick={props.onClick}>
      <div className="image-Container">
        <img src={props.imageUrl} alt="" />
      </div>
      <div className="card-title">
        <h3>{props.title}</h3>
      </div>
      <div className="card-body">
        <h4>{props.description}</h4>
      </div>
    </div>
  );
};

export const CardList = () => {
  const history = useHistory();
  return (
    <div className="card-list">
      <Card
      onClick={() => history.push('/services')}
        title="Mobile Application Development"
        imageUrl={MobileImage}
        description="Mobile app development"
      />

      <Card
      onClick={() => history.push('/services')}
        title="Web Development"
        imageUrl={WebImage}
        description=" Web development"
      />

      <Card
      onClick={() => history.push('/services')}
        title="DevOps"
        imageUrl={DevOpsImage}
        description="Devops"
      />

      <Card
      onClick={() => history.push('/services')}
        title="Art  & Design"
        imageUrl={ArtImage}
        description="Art & Design"
      />

      <Card
        title="API Development"
        imageUrl={GameImage}
        description="API Development"
      />

      {/* <Card
        title="Data Management"
        imageUrl={DataImage}
        description="Tailored, white-label mobile app development"
      /> */}
    </div>
  );
};
